import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Pet, Vehicle } from '../models/user-profile.model';
import { VehiculoService } from '../services/vehiculo.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog';

@Component({
  selector: 'app-profile-registros',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile-registros.component.html',
  styleUrls: ['./profile-registros.component.scss']
})
export class ProfileRegistrosComponent implements OnInit, OnDestroy {

  private readonly baseUrl = environment.apiBaseUrl;

  private router = inject(Router);
  private vehiculoService = inject(VehiculoService);
  private http = inject(HttpClient);
  private snackbar = inject(MatSnackBar);
  private dialog = inject(MatDialog);

  private destroy$ = new Subject<void>();

  mascotas: Pet[] = [];
  vehiculos: Vehicle[] = [];

  ngOnInit() {
    this.loadRegistros();

    this.vehiculoService.actualizacionVehiculos$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadRegistros());
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadRegistros() {
    const profileData = localStorage.getItem('profileData');
    if (profileData) {
      const data = JSON.parse(profileData);
      this.mascotas = data.pets || [];
      this.vehiculos = data.vehicles || [];
    }
  }

  onAddMascota() {
    this.router.navigate(['/add-mascota']);
  }

  onAddVehiculo() {
    this.router.navigate(['/add-vehiculo']);
  }

 onEdit(item: Pet | Vehicle, type: string) {
  if (type === 'mascota') {
    const pet = item as Pet;
    this.router.navigate(['/add-mascota'],{ queryParams: {
            id: pet.idPet, 
            operation: 'update',
            update :true 
          },skipLocationChange:true}
        );


  } else if (type === 'vehiculo') {
    const vehicle = item as Vehicle
    sessionStorage.setItem('vehicleParaEditar', JSON.stringify(vehicle));
    this.router.navigate(['/add-vehiculo']);

  }
}



  onDelete(item: Pet | Vehicle, type: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        const token = localStorage.getItem('accessToken') || '';
        const cognitoId = localStorage.getItem('cognito') || '';

        let url = '';
        let petition = {};

        if (type === 'mascota') {
          url = `${this.baseUrl}/pet/${cognitoId}/delete`;
          petition = { idPet: (item as Pet).idPet };
        } else {
          url = `${this.baseUrl}/vehicle/${cognitoId}/delete`;
          petition = { vehicleId: (item as Vehicle).id };
        }


        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        });

        const body = {
          identifier: {
            tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
            app: 'PortalAsistencia',
          },
          petition
        };

        this.http.request('delete', url, { body, headers }).subscribe({
          next: () => {
            const profileDataStr = localStorage.getItem('profileData');
            if (profileDataStr) {
              const profileData = JSON.parse(profileDataStr);

              if (type === 'mascota') {
                profileData.pets = this.mascotas.filter(d => d !== item);
              } else {
                profileData.vehicles = this.vehiculos.filter(d => d !== item);
              }

              localStorage.setItem('profileData', JSON.stringify(profileData));
            }

            this.snackbar.open(`${type} eliminada correctamente.`, 'Cerrar', { duration: 3000 });
            this.loadRegistros();
          },
          error: (error) => {
            this.snackbar.open(`Error eliminando ${type}. Intenta de nuevo.`, 'Cerrar', { duration: 3000 });
          }
        });

      } else {
        this.snackbar.open('Eliminación cancelada.', 'Cerrar', { duration: 2000 });
      }
    });
  }

  onGoBack() {
    this.router.navigate(['/headerprofile']);
  }
}
///moment 